export default __webpack_public_path__ + "static/media/icon-checkmark-base.88c5b66c.svg";